<template>
  <div class="container" v-if="!isLoading">
    <div class="row">
      <div class="col-12">
        <TopNav class="mt-4" />
        <img class="mt-3" :src="`${logo}`" />
        <p class="mt-4 mb-3">
          {{ $t('SETTINGS.TEXT.CONNECT_YOUR_SMTP_ACCOUNT') }}
        </p>
        <HMActivatedTag
          v-if="!inProgress && smtp.is_smtp_connected"
          :label="$t('SETTINGS.LABEL.CONNECTED')"
          class="my-3"
        />
      </div>
    </div>
    <ValidationObserver
      class="row"
      @submit.prevent="update"
      tag="form"
      ref="form"
      v-slot="{ invalid }"
    >
      <HMTextInput
        class="col-12 col-md-6"
        type="text"
        :label="$t('SETTINGS.LABEL.FROM_NAME')"
        v-model="smtp.smtp_display_name"
        name="Your display name"
        rules="required"
      />
      <HMTextInput
        class="col-12 col-md-6"
        type="text"
        rules="required"
        :label="$t('SETTINGS.LABEL.EMAIL_ADDRESS')"
        v-model="smtp.smtp_email"
        name="SMTP Server port"
      />
      <HMTextInput
        class="col-12 col-md-6"
        type="text"
        rules="required"
        :label="$t('SETTINGS.LABEL.SERVER')"
        v-model="smtp.smtp_host"
        name="SMTP Server hostname"
      />
      <HMTextInput
        class="col-12 col-md-6"
        type="text"
        rules="required"
        :label="$t('SETTINGS.LABEL.PORT')"
        v-model="smtp.smtp_port"
        name="SMTP Server port"
      />
      <HMTextInput
        class="col-12 col-md-5"
        type="text"
        rules="required"
        :label="$t('SETTINGS.LABEL.ACCOUNT_USERNAME')"
        v-model="smtp.smtp_username"
        name="SMTP Server username"
      />
      <HMTextInput
        class="col-12 col-md-5"
        type="password"
        rules="required"
        :label="$t('SETTINGS.LABEL.ACCOUNT_PASSWORD')"
        v-model="smtp.smtp_password"
        name="SMTP Server password"
      />
      <div class="col-12 col-md-2">
        <label>
          {{ $t('SETTINGS.LABEL.EMAIL_SECURITY') }}
        </label>
        <v-select
          :options="securityTypes"
          v-model="selectedSecurity"
          :reduce="s => s.code"
        />
      </div>
      <div class="col-12 d-flex flex-row">
        <HMButton
          type="submit"
          color="brand"
          :loading="inProgress"
          :disabled="invalid || inProgress"
        >
          {{ $t('GENERAL.BUTTON.SAVE') }}
        </HMButton>
        <div v-if="smtp.is_smtp_connected">
          <HMButton
            class="ml-3"
            color="outline-light-gray"
            @click="remove"
            :loading="inProgress"
            :disabled="inProgress"
          >
            {{ $t('SETTINGS.BUTTON.DISCONNECT_SMTP') }}
          </HMButton>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import Vue from 'vue';

import TopNav from '@/web/components/navigation/TopNav.vue';
import { errorToMessage } from '@/core/utils/errors';
import HMTextInput from '../../../components/common/HMTextInput';
import HMButton from '../../../components/common/HMButton';
import { ValidationObserver } from 'vee-validate';

export default Vue.extend({
  name: 'SmtpIntegration',
  components: {
    HMButton,
    HMTextInput,
    TopNav,
    ValidationObserver,
  },
  computed: {
    securityTypes() {
      return [
        {
          label: this.$t('SETTINGS.LABEL.NONE'),
          code: 'none',
        },
        {
          label: this.$t('SETTINGS.LABEL.TLS'),
          code: 'tls',
        },
        {
          label: this.$t('SETTINGS.LABEL.SSL'),
          code: 'ssl',
        },
      ];
    },
    selectedSecurity: {
      get() {
        if (this.smtp.smtp_use_tls) return 'tls';
        if (this.smtp.smtp_use_ssl) return 'ssl';
        return 'none';
      },
      set(security) {
        this.smtp.smtp_use_tls = false;
        this.smtp.smtp_use_ssl = false;
        if (security === 'tls') this.smtp.smtp_use_tls = true;
        if (security === 'ssl') this.smtp.smtp_use_ssl = true;
      },
    },
  },
  data() {
    return {
      logo: '/assets/images/integrations/smtp.svg',
      isLoading: true,
      inProgress: false,
      smtp: {},
    };
  },
  methods: {
    async update() {
      try {
        this.inProgress = true;
        this.smtp = await this.$store.dispatch(
          'setting/updateSmtpInfo',
          this.smtp
        );
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('SETTINGS.NOTIFICATIONS.SMTP_SUCCESSFULLY_UPDATED'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error.response),
        });
        this.smtp.is_smtp_connected = false;
      } finally {
        this.inProgress = false;
      }
    },
    remove() {
      this.smtp.smtp_display_name = null;
      this.smtp.smtp_email = null;
      this.smtp.smtp_host = null;
      this.smtp.smtp_port = null;
      this.smtp.smtp_username = null;
      this.smtp.smtp_password = null;
      this.smtp.smtp_use_tls = false;
      this.smtp.smtp_use_ssl = false;
      this.smtp.is_smtp_connected = false;
      this.update();
    },
  },
  async mounted() {
    this.smtp = await this.$store.dispatch('setting/getSmtpInfo');
    this.isLoading = false;
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

#twilio-connect-button {
  background: url(https://www.twilio.com/bundles/connect-apps/img/connect-button.png);
  width: 130px;
  height: 34px;
  display: block;
  margin: 0 auto;
}
</style>
